import { PROCESS_FIELD_ERROR, VERIFY_FORM_VALIDITY } from "./form-errors-action-types";

const initialFormErrors = {
    isFormValid: false,
    first_name: false,
    last_name: false,
    email: false,
    phone: false,
    company: false,
    institutionSize1: false,
    role: false,
    howDidYouHearAboutUs1: false,
    anythingtoadd: false,
    productSolutionOfInterest1: false
};

const formErrorReducer = (state = initialFormErrors, action) => {
    switch (action.type) {
        case PROCESS_FIELD_ERROR:
            return {
                ...state,
                [action.fieldName]: action.validity
            };
        case VERIFY_FORM_VALIDITY:
            return {
                ...state,
                isFormValid: action.validity
            };
        default:
            return state;
    }
};

export default formErrorReducer;
